import React from 'react';
import PropTypes from 'prop-types';
import { VCARD_RESUMEN_MAIN_CLASSNAME, VCARD_RESUMEN_SHORT_MAIN_CLASSNAME } from '../Constants';
import { cls } from '../../../packages/components';
import Translator from '../../../requests/apa/Translator';
import Utils from "../../../utils/Utils";

const GENDER_MAX = 2;

class VCardResume extends React.PureComponent {
    constructor(props) {
        super(props);
        // Cache para estilo de barra de progreso
        this._cachedProgressStyle = null;
        this._prevProgressWidth = undefined;
    }

    componentWillUnmount() {
        this._cachedProgressStyle = null;
    }

    isNumber(value) {
        return typeof value === 'number';
    }

    hasBookmark(bookMarkEpisode) {
        return bookMarkEpisode === true || (this.isNumber(bookMarkEpisode) && bookMarkEpisode > 0);
    }

    render(){
        const {title, subtitle, episode, genders, year, parentalRating, duration, synopsis, addonDescription, progress, isLoading, dataEpisodes, notification } = this.props;
        const showProgressBar = progress !== 0;
        let synopsisEpisode = synopsis;
        let numberEpisode = '';
        let titleEpisode = '';
        let bookMarkEpisode = progress !== 0;

        if (dataEpisodes !== '') {
            synopsisEpisode = dataEpisodes.data.description_large;
            numberEpisode = dataEpisodes.data.episode_number;
            titleEpisode = dataEpisodes.data.title_episode;
            bookMarkEpisode = dataEpisodes.data.bookmark !== 0 ? dataEpisodes.data.bookmark : '';
        }

        const sizeProgressBar = progress === 0 && !showProgressBar && dataEpisodes !== '' ? bookMarkEpisode : progress;
        const stylesEpisodeBookMark = bookMarkEpisode ? true : false;

        // Cache progress bar style
        if (sizeProgressBar !== this._prevProgressWidth) {
            this._prevProgressWidth = sizeProgressBar;
            this._cachedProgressStyle = { width: sizeProgressBar + '%' };
        }

        return (
            <div className={VCARD_RESUMEN_MAIN_CLASSNAME}>
                <div className={cls(`${VCARD_RESUMEN_MAIN_CLASSNAME}-title weight`, {"bg-loading-title":isLoading})}>
                    {title}
                </div>
                <div className={cls(VCARD_RESUMEN_SHORT_MAIN_CLASSNAME, `space-bottom${episode ? '-serie' : ''}`, {"bg-loading-resume-short":isLoading})}>
                    <p className="bold original-title">{subtitle}</p> {subtitle && '|'} <span>{genders.slice(0,GENDER_MAX).join(', ')}</span> <span>{year}</span> {parentalRating && <span className="bordered">{parentalRating}</span>} <span className="bold">{duration}</span>
                </div>
                {episode && <div className={`${VCARD_RESUMEN_MAIN_CLASSNAME}-serie-title`}>
                    <span>
                        {`${Translator.get('vcard-serie-title-season', 'Temporada')} ${episode.season}`}
                    </span> {episode && '|'}{' '}
                    <span>
                        {dataEpisodes !== '' ? `${Translator.get('vcard-serie-title-episode', 'Episodio')} ${numberEpisode}`
                            : `${Translator.get('vcard-serie-title-episode', 'Episodio')} ${episode.number}`}
                    </span>:{' '}
                    <p className="bold episode-name">{dataEpisodes !== '' ? titleEpisode :  episode.name}</p>
                </div>}
                <div className={cls(`${VCARD_RESUMEN_MAIN_CLASSNAME}-synopsis`, {'space-bottom':stylesEpisodeBookMark, "bg-loading-synopsis":isLoading})}>
                     {synopsisEpisode}
                </div>
                {this.hasBookmark(bookMarkEpisode) &&
                    <div className={`${VCARD_RESUMEN_MAIN_CLASSNAME}-progress-bar`}>
                        <div style={this._cachedProgressStyle}/>
                    </div>
                }
                {addonDescription}
                {notification}
            </div>
        );
    }
}


VCardResume.propTypes = {
    title: PropTypes.string.isRequired,
    subtitle: PropTypes.string,
    genders: PropTypes.arrayOf(PropTypes.string).isRequired,
    parentalRating: PropTypes.string.isRequired,
    duration: PropTypes.string.isRequired,
    synopsis: PropTypes.string.isRequired,
    addonDescription: PropTypes.node,
    progress: PropTypes.number,
    episode: PropTypes.object,
    isLoading: PropTypes.bool.isRequired,
    notification: PropTypes.element,
}

VCardResume.defaultProps = {
    title: '',
    subtitle:'',
    genders:[],
    parentalRating:'',
    duration:'',
    synopsis: '',
    addonDescription: null,
    progress: 0,
    episode: null,
    isLoading: false,
    notification: null,
}

export default VCardResume;



// WEBPACK FOOTER //
// ./src/components/Ficha/components/VCardResume.jsx